import lodash from 'lodash'
import React, { useEffect, useRef } from 'react'
import { Container } from 'react-bootstrap'
import { useCookies } from 'react-cookie'
import styled from 'styled-components'

import Icon from '../../../1stlog-ui/src/components/Icon'

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
`

const ContainerWrapper = styled.div`
  background: white;
  padding: 1em;
  width: 100%;
  box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.2);
`

const TextWrapper = styled.div`
  flex: 1;
`

const ButtonWrapper = styled.div``

const COOKIE_NAME = 'cookieConsentAccepted'

const CookieConsent = (props) => {
  const refWrapper = useRef()

  const [cookies, setCookie] = useCookies([COOKIE_NAME])

  const accepted = lodash.get(cookies, COOKIE_NAME)

  useEffect(() => {
    // setTimeout(() => {
    //   if (refWrapper.current) {
    //     refWrapper.current.focus()
    //   }
    // }, 1)
  }, [])

  const close = () => {
    setCookie(COOKIE_NAME, true, {
      path: '/',
      expires: new Date(2147483647 * 1000),
    })
  }

  if (accepted) {
    return null
  }

  return (
    <Wrapper ref={refWrapper}>
      <div className="flex-fill" onClick={close}></div>
      <ContainerWrapper>
        <Container className="d-flex">
          <TextWrapper>
            <h4>{i18n.t(`note`, `Hinweis`)}</h4>
            <p>
              Diese Website oder ihre Drittanbieter-Tools verwenden Cookies, die
              für die Funktionalität notwendig sind und um die in den
              Cookie-Richtlinien dargelegten Zwecke zu erreichen. Wenn Sie mehr
              erfahren oder Ihre Zustimmung gegenüber allen oder einzelnen
              Cookies zurückziehen möchten, ziehen Sie bitte die{' '}
              <a
                href="//www.1st-log.com/de/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                Cookie-Richtlinien
              </a>{' '}
              zurate.
            </p>
            <p>
              Indem Sie dieses Banner schließen, die Seite nach unten scrollen,
              einen Link anklicken oder Ihre Recherche auf andere Weise
              fortsetzen, erklären Sie sich mit dem Gebrauch von Cookies
              einverstanden.
            </p>
          </TextWrapper>

          <ButtonWrapper>
            <Icon size={1.5} icon="fal fa-times" onClick={close} />
          </ButtonWrapper>
        </Container>
      </ContainerWrapper>
    </Wrapper>
  )
}

export default CookieConsent
